import { render } from "./Monitor.vue?vue&type=template&id=1084f744&scoped=true"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"

import "./Monitor.vue?vue&type=style&index=0&id=1084f744&scoped=true&lang=css"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1084f744"]])

export default __exports__